import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { MdDialogRef } from '@angular/material';

import { FormHelper } from '../../helpers/form-helper';
import { Meetup } from '../../models/meetup';
import { MeetupService } from '../../services/meetup.service';

@Component(
{
  selector: 'app-add-meetup',
  templateUrl: './add-meetup.component.html',
  styleUrls: ['./add-meetup.component.scss']
})
export class AddMeetupComponent extends FormHelper implements OnInit {

  constructor(private dialogRef: MdDialogRef<AddMeetupComponent>,
							private formBuilder: FormBuilder,
							private meetupService: MeetupService) {
		super();

		this.buildForm();
	}

  ngOnInit() {
  }

	public buildForm(): void {
		this.form = this.formBuilder.group({
			description: new FormControl('', Validators.required),
			number: new FormControl('', Validators.required),
			startsAt: new FormControl('', Validators.required),
			endsAt: new FormControl('', Validators.required),
			maxCouples: new FormControl('', Validators.required),
			coupleCost: new FormControl('', Validators.required)
		});
	}

	public submitForm(): void {
		let meetup: Meetup = this.form.value;

		meetup.confirmedCouples = 0;
		meetup.pendingCouples = 0;
		meetup.startsAt = new Date(this.form.controls['startsAt'].value + 'T10:20:30Z').getTime();
		meetup.endsAt = new Date(this.form.controls['endsAt'].value + 'T10:20:30Z').getTime();

		this.meetupService.addMeetup(meetup);

		this.dialogRef.close();
	}
}



// WEBPACK FOOTER //
// C:/Source/Ecim/Ecim.Web/src/app/components/add-meetup/add-meetup.component.ts